<!-- Print div -->
<!-- Displayed using [ngStyle] value of displayType -->
<mat-grid-list id="print" cols="1" rows="1" rowHeight="fit" [ngStyle]="{display: displayType}">
    <mat-grid-tile>
        <mat-card>

            <!-- Print "Main" (Default) -->
            <!-- Displayed if showDiv.printMain is true (default of 3 options) -->
            <div *ngIf="showDiv.printMain">
                <br>
                <h2>Choose a report to print:</h2>
                <h3>Map Report:</h3>
                <div><button mat-raised-button color="primary" (click)="showMapReport()">Map Report</button>
                    <p>A report containing a map of the current extent with legend and other technical information.</p>
                </div><br>
                <h3>Basin Report:</h3>
                <div><button mat-raised-button color="primary" (click)="showBasinReport()">Basin Report</button><br>
                    <p>A report containing tabular data about the selected basin.</p>
                </div><br>
                <div><button mat-raised-button color="accent" (click)="onPrintCancel()">Cancel</button></div>
            </div>

            <!-- Map Report -->
            <!-- Displayed if showDiv.mapRpt is true (2 of 3 options) -->
            <div *ngIf="showDiv.mapRpt">
                <br>
                <h2>Map Report</h2>
                <div><b>Step 1:</b> Select the point of interest on the map.</div><br>
                <div><b>Step 2:</b> Enter an optional comment about the map such as an address or parcel ID number:</div><br>
                <div>
                    <mat-form-field class="form-field">
                        <mat-label>Map Comments (Optional):</mat-label>
                        <input matInput type="text" [(ngModel)]="userComms">
                        <button *ngIf="userComms" matSuffix mat-icon-button aria-label="Clear" (click)="userComms=''">
                          <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-form-field>
                </div><br>
                <!-- The map report button is disabled, using printMapPointSelected as false, if a user has not selected a location on the map -->
                <!-- Otherwise, if a user has selected a location on the map, generate a .png print of the map report -->
                <div><button mat-raised-button color="primary" [disabled]="printMapPointSelected === false ? true : null" (click)="printLFEOmapLayout()">Print Map Report</button><span class="sr-only">For an accessible version of this PDF, please email us at floodplain.dnr@state.mn.us.</span></div><br>
                <div><button mat-raised-button color="accent" (click)="onPrintCancel()">Cancel</button></div>
            </div>

            <!-- Basin Report -->
            <!-- Displayed if showDiv.basinRpt is true (3 of 3 options) -->
            <div *ngIf="showDiv.basinRpt">
                <br>
                <h2>Basin Report</h2><br>
                <div>Select the basin of interest on the map.</div><br>

                <!-- Selected basin drop-down menu -->
                <!-- If only one value is selected, the dropdown is disabled -->
                <!-- If multiple records are selected, the dropdown is activated and the user can select from the basin menu -->
                <mat-form-field appearance="fill" style="width:30vw;">
                    <mat-label>Basin selected</mat-label>
                    <mat-select [(ngModel)]="basinStuff" [disabled]="basinFeature?.length <= 1">
                        <mat-option *ngFor="let basin of basinFeature" [value]="basin.attributes">
                            {{basin.attributes.pw_basin_name}}
                        </mat-option>
                    </mat-select> 
                </mat-form-field>

                <!-- The basin report button is disabled, using printBasinSelect as false, if a user has not selected a basin on the map -->
                <!-- Otherwise, if a user has selected a basin on the map, generate a .png print of the basin report -->
                <div><button mat-raised-button color="primary" [disabled]="printBasinSelected === false ? true : null" (click)="printLFEOBasinReport()">Print Basin Report<span class="sr-only">For an accessible version of this PDF, please email us at floodplain.dnr@state.mn.us.</span></button></div><br>
                <div><button mat-raised-button color="accent" (click)="onPrintCancel()">Cancel</button></div>
            </div>
            <div *ngIf="showDiv.waitMsg">
                <br>
                <h3>Generating Report ...  This may take a minute</h3>
            </div>
            <div *ngIf="showDiv.finishedMsg">
                <br>
                <h3>Report has been generated.  If it doesn't appear in a separate browser window you can turn off popup blockers in your 
                    browser or click <a [href]="reportURL" target="_blank">HERE</a></h3>
            </div>

        </mat-card>
    </mat-grid-tile>
</mat-grid-list>